import { useState, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import CustomDateInput from '../../ui/Form/CustomDateInput';
import CustomInput from '../../ui/Form/CustomInput';
// import CustomSelect from '../../ui/Form/CustomSelect';
import {
  getDocumentTypeToApi,
  getGenderToApi,
  dateFormatter,
  getDateByStringDate,
  getYearsByDate,
  isEmptyObject,
  getCountryByCode,
  allowStateResidenceByCountry,
  allowZipCodeByCountry,
  clearCustomFormatter,
  getSexByCode,
  getStateResidenByCode,
} from '../../utils/index';
import { useUpdateGuestMutation } from '../../services/majesticResortsApi';
import MessageErrorModal from '../../ui/Modals/MessageErrorModal';
import CustomInputPhoneNumber from '../../ui/Form/CustomInputPhoneNumber';
import GenderList from '../../utils/GenderList';
import CountryExtendedList from '../../utils/CountryExtendedList';
import CountrySelect from '../../ui/Form/CountrySelect.';
import GenderSelect from '../../ui/Form/GenderSelect';

function GuestDocumentationEditPage() {
  const { language } = useSelector((state) => state.checking);
  const { booking } = useSelector((state) => state.booking);
  const { selectedGuest } = useSelector((state) => state.guests);
  const [dataGuest, setDataGuest] = useState({});
  const [defaultCountry, setDefaultCountry] = useState({});
  const [defaultResidence, setDefaultResidence] = useState({});
  const [defaultSex, setDefaultSex] = useState({});
  const [isFormUpdated, setIsFormUpdated] = useState(false);
  const [updateGuest, { isError, error }] = useUpdateGuestMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const {
    control,
    reset,
    trigger,
    register,
    setValue,
    watch,
    formState,
    handleSubmit,
  } = useForm();

  const { isValid } = formState;

  useEffect(() => {
    if (!isEmptyObject(selectedGuest)) {
      const setDataOnForm = async () => {
        const dataCountry = getCountryByCode(selectedGuest?.PaisNacimiento);
        const residence = getCountryByCode(selectedGuest?.DatosComunicacion.Pais);
        const sex = getSexByCode(selectedGuest?.FormatterSexoShort);
        // TODO: Agregar el componente stateSelector y pasarle el listado de stateList.jsx
        const dataState = getStateResidenByCode(selectedGuest.DatosComunicacion.Provincia);
        // console.log(dataState);
        // console.log(getCountryByCode(selectedGuest.PaisNacimiento));

        const inputValues = {
          name: selectedGuest.Nombre_Pila,
          // firstName: selectedGuest.Nombre,
          lastNames: selectedGuest.Nombre,
          birthDate: getDateByStringDate(selectedGuest.FormatterFechaNacimiento, 'DD/MM/YYYY'),
          gender: selectedGuest.FormatterSexoShort,
          expirationDate: getDateByStringDate(selectedGuest.FormatterFechaCaducidad, 'DD/MM/YYYY'),
          expeditionDate: getDateByStringDate(selectedGuest.FormatterFechaExpedicion, 'DD/MM/YYYY'),
          nationality: dataCountry.nameES,
          country: dataCountry,
          documentNumber: selectedGuest.IDDocumento,
          documentType: selectedGuest.FormatterTipoDocumento,
          phoneNumber: selectedGuest.DatosComunicacion.Telefono,
          email: selectedGuest.Email,
          stateResidence: dataState[`name${language.toUpperCase()}`],
          zipCode: selectedGuest.DatosComunicacion.CodigoPostal,
        };

        setDataGuest(inputValues);
        setDefaultResidence(residence);
        setDefaultCountry(dataCountry);
        setDefaultSex(sex);

        // Establece los valores en los inputs
        await reset(inputValues, { keepDirtyValues: true, keepDirty: true });
        // Dispara la validacion global despues de establecer los valores
        // await trigger();
      };

      setDataOnForm();
    }
  }, [reset, trigger, selectedGuest]);

  console.log(isValid);
  useEffect(() => {
    const subscription = watch((values) => {
      // Compara los valores actuales con los valores iniciales
      const isDifferent = JSON.stringify(values) !== JSON.stringify(dataGuest);
      console.log(isDifferent);
      setIsFormUpdated(isDifferent);
    });

    return () => subscription.unsubscribe();
  }, [watch, dataGuest]);

  const onSubmit = async (data) => {
    let updatedGuest = {
      ...selectedGuest,
      DatosComunicacion: {
        ...selectedGuest.DatosComunicacion,
        Telefono: data.phoneNumber.replace(/[\s_]/g, ''),
        EMail: data.email,
        Pais: data.country.iso2,
        // ComunidadAutonoma: data.stateResidence, // TODO: PAIS formato: XX
      },
      Email: data.email,
      TipoDocumento: getDocumentTypeToApi(data.documentType),
      Nombre_Pila: data.name,
      Nombre: data.lastNames,
      FechaNacimiento: dateFormatter(data.birthDate, 'YYYYMMDD000000'),
      FechaExpedicion: dateFormatter(data.expeditionDate, 'YYYYMMDD000000'),
      FechaCaducidad: dateFormatter(data.expirationDate, 'YYYYMMDD000000'),
      Edad: `0${getYearsByDate(data.birthDate)}`,
      IDDocumento: data.documentNumber,
      Sexo: getGenderToApi(data.gender.Name),
      PaisNacimiento: data.country.iso2,
    };

    // if (allowStateResidenceByCountry(nationality)) {
    //   newGuest.DatosComunicacion.ComunidadAutonoma = dataResidence.stateName;
    // }

    // if (allowZipCodeByCountry(nationality)) {
    //   newGuest.DatosComunicacion.CodigoPostal = dataResidence.zipCode;
    //   // documentTypeList.push('turismo');
    // }

    updatedGuest = clearCustomFormatter(updatedGuest);

    const params = { d: updatedGuest };

    await updateGuest(params).unwrap();
    navigate('/Booking');
  };

  const handleChange = (selectedOption) => {
    console.log('Seleccionado:', selectedOption);
  };

  const onError = (errorList) => {
    console.log(errorList);
  };

  const handleShowStateResidence = () => {
    const allowList = ['CAN', 'USA'];
    return allowList.includes(defaultResidence.iso3) && booking.HotelFactura === 'M4';
  };

  const handleShowZipCode = () => {
    const allowList = ['MEX', 'DOM'];
    return allowList.includes(defaultResidence.iso3);
  };

  const showZipCodeDom = () => (defaultResidence.iso3 === 'DOM' && booking.HotelFactura !== 'M4');

  const showZipCodeMex = () => (defaultResidence.iso3 === 'MEX' && booking.HotelFactura === 'M4');

  return (
    <div className="guest__documentation-edit d-flex flex-column h-100" id="guest__documentation-edit">
      <div className="text-center mb-1">
        {/* <p className="mb-0 app-txt-red app-fs-12 text-uppercase">{t('TXT_EDIT_REGISTER')}</p> */}

        <p className="mb-1 app-fs-h4 app-lh-h4 app-txt-granite app-fw-notosans-bold">
          {t('TXT_REGISTER_GUEST_NUMBER', { numberGuest: selectedGuest?.customNumber })}
        </p>
        <p className="mb-3 app-fs-12 app-txt-granite-80-dark">
          { t(`TXT_BETWEEN_YEARS_PERSON_TYPE_0${selectedGuest.TipoPersona}`) }
        </p>
      </div>

      <FormProvider
        control={control}
        handleSubmit={handleSubmit}
        setValue={setValue}
        watch={watch}
        formState={formState}
        register={register}
      >
        <Form onSubmit={handleSubmit(onSubmit, onError)} className="dr__form">
          <CustomInput
            control={control}
            name="name"
            formLabel={t('TXT_NAME')}
            defaultValue={dataGuest.name}
            rules={{ required: true }}
            disabled
            classNames={{
              card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
              cardBody: 'px-2 py-1',
              label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
              input: 'app-txt-granite-80-dark app-fs-14',
            }}
          />
          <CustomInput
            control={control}
            name="lastNames"
            formLabel={t('TXT_LAST_NAMES')}
            defaultValue={dataGuest.lastNames}
            rules={{ required: true }}
            disabled
            classNames={{
              card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
              cardBody: 'px-2 py-1',
              label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
              input: 'app-txt-granite-80-dark app-fs-14',
            }}
          />

          <Row className="mx-">
            <Col xs={6} sm={6} lg={6} className="pe-1">
              <CountrySelect
                control={control}
                name="country"
                formLabel={t('TXT_NATIONALITY')}
                rules={{ required: `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_NATIONALITY') })}` }}
                disabled
                defaultValue={defaultCountry}
                options={CountryExtendedList}
                optionName="nameES"
                optionCode="iso2"
                classNamePrefix="form-review"
                handleOnChange={handleChange}
                controlHeight={20}
                classNames={{
                  card: 'border-solid-1 transition-border-color border-gray mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                }}
              />
            </Col>
            <Col xs={6} sm={6} lg={6} className="ps-1">
              <CustomDateInput
                control={control}
                name="birthDate"
                rules={{ required: true }}
                defaultValue={dataGuest.birthDate}
                formLabel={t('TXT_BIRTH_DATE')}
                labelId="birthDate"
                blockDate={false}
                blockFutureDate
                showMoth
                showYear
                disabled
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
            </Col>
          </Row>
          <Row className="mx-">
            <Col xs={12} sm={12} lg={12}>
              <CustomInput
                control={control}
                name="documentNumber"
                formLabel={t('TXT_NUMBER_DOCUMENT')}
                defaultValue={dataGuest.documentNumber}
                rules={{ required: true }}
                disabled
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark app-fs-14',
                }}
              />
            </Col>
          </Row>
          <Row className="mx-">
            <Col xs={6} sm={6} lg={6} className="pe-1">
              <GenderSelect
                control={control}
                name="gender"
                formLabel={t('TXT_SELECT_SEX')}
                rules={{ required: `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_SELECT_SEX') })}` }}
                disabled
                defaultValue={defaultSex}
                options={GenderList}
                classNamePrefix="form-review"
                handleOnChange={handleChange}
                controlHeight={20}
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark',
                }}
              />
              <CustomDateInput
                control={control}
                name="expeditionDate"
                rules={{ required: true }}
                defaultValue={dataGuest.expeditionDate}
                formLabel={t('TXT_EXPEDITION_DATE')}
                labelId="expeditionDate"
                blockFutureDate={booking.FechaEntrada}
                showMoth
                showYear
                disabled
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
            </Col>
            <Col xs={6} sm={6} lg={6} className="ps-1">
              <CustomInput
                disabled
                control={control}
                name="documentType"
                formLabel={t('TXT_DOCUMENT_TYPE')}
                defaultValue={dataGuest.documentType}
                rules={{ required: true }}
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
              <CustomDateInput
                control={control}
                name="expirationDate"
                rules={{ required: true }}
                defaultValue={dataGuest.expirationDate}
                formLabel={t('TXT_EXPIRATION_DATE')}
                labelId="expirationDate"
                blockDate={booking.FechaEntrada}
                showMoth
                showYear
                disabled
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={12} lg={12} className="mt-2 text-center">
              <p className="mb-1 app-fs-h6 app-lh-h6 app-txt-granite app-fw-notosans-bold">{t('TXT_RESIDENCE')}</p>
              <hr className="mt-0 app-txt-gold" />
            </Col>
            <Col xs={12} sm={12} lg={12}>
              <CustomInput
                control={control}
                name="email"
                formLabel="E-mail*"
                typeInput="email"
                disabled
                defaultValue={selectedGuest.Email}
                rules={{ required: true }}
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
            </Col>
            <CountrySelect
              control={control}
              name="countryResidence"
              formLabel={t('TXT_COUNTRY_RESIDENCE')}
              rules={{ required: `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_COUNTRY_RESIDENCE') })}` }}
              disabled
              defaultValue={defaultResidence}
              options={CountryExtendedList}
              optionName="nameES"
              optionCode="iso2"
              classNamePrefix="form-review"
              handleOnChange={handleChange}
              controlHeight={20}
              classNames={{
                card: 'rounded-end-0 border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                cardBody: 'px-2 py-1',
                label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                input: 'app-txt-granite-80-dark',
              }}
            />
            {handleShowStateResidence() && (
              <CustomInput
                defaultValue={dataGuest.stateResidence}
                control={control}
                name="stateResidence"
                formLabel={t('TXT_STATE_RESIDENCE')}
                rules={{ required: true }}
                disabled
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
            )}
            {((showZipCodeDom() || showZipCodeMex())) && (
              <CustomInput
                control={control}
                name="zipCode"
                formLabel={t('TXT_ZIP_CODE')}
                defaultValue={dataGuest.zipCode}
                clearCaracter
                disabled
                rules={{
                  required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_ZIP_CODE') })}`,
                  minLength: {
                    value: 5,
                    message: `${t('TXT_ERROR_MIN_ZIP_CODE')}`,
                  },
                  maxLength: {
                    value: 7,
                    message: `${t('TXT_ERROR_MAX_ZIP_CODE')}`,
                  },
                }}
                classNames={{
                  card: 'border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                  input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                }}
              />
            )}
            <Col xs={12} sm={12} lg={12}>
              <div className="d-flex">
                <CountrySelect
                  control={control}
                  name="phoneKey"
                  formLabel={t('TXT_KEY')}
                  rules={{ required: `${t('TXT_ERROR_THE_INPUT_REQUIRED', { inputName: t('TXT_KEY') })}` }}
                  disabled
                  defaultValue={defaultCountry}
                  options={CountryExtendedList}
                  classNamePrefix="form-review"
                  handleOnChange={handleChange}
                  controlHeight={24}
                  styles={{ width: '150px' }}
                  classNames={{
                    card: 'rounded-end-0 border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                    cardBody: 'px-2 py-1',
                    label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                    input: 'app-txt-granite-80-dark',
                  }}
                />
                <CustomInputPhoneNumber
                  control={control}
                  name="phoneNumber"
                  formLabel={t('TXT_TELEPHONE')}
                  defaultValue={dataGuest.phoneNumber}
                  rules={{ required: true }}
                  disabled
                  classNames={{
                    card: 'rounded-start-0 border-solid-1 app-border-granite-80-light transition-border-color border-radius-5 mb-2',
                    cardBody: 'px-2 py-1',
                    label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                    input: 'app-txt-granite-80-dark shadow-none py-0 app-fs-14',
                  }}
                />
              </div>
            </Col>
          </Row>

          <div className="mt-3 mb-2">
            {/* <Button
              variant="link"
              type="button"
              onClick={() => navigate('/Booking')}
              className="app-bg-red app-txt-red app-fs-18 btn-height bg-transparent"
            >
              {t('TXT_BOTON_CANCEL')}
            </Button> */}
            {/* <Button
              // disabled={!(isFormUpdated && isValid)}
              disabled
              variant=""
              type="submit"
              className="app-bg-red text-white app-fw-segoe-bold app-fs-20 px-5 rounded-3 float-end btn-height"
            >
              {t('TXT_BOTON_SAVE')}
            </Button> */}
          </div>
        </Form>
      </FormProvider>

      {isError && <MessageErrorModal message={error.message} />}
    </div>
  );
}

export default GuestDocumentationEditPage;
